import styled from 'styled-components';

import Button from 'components/Buttons/Button';

export const ButtonContainer = styled.div`
  display: flex;

  @media ${({ theme }) => theme.device.desktop} {
    position: sticky;
    bottom: 0;
    margin-top: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.rule.ruleList.white};
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
  }
`;

export const StyledButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0px 16px 32px 16px;
  }
`;

export const BoxContainer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border: 1px ${({ theme }) => theme.rule.ruleList.lightGrey};
  border-style: solid none;
  background-color: ${({ theme }) => theme.rule.ruleList.white};

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    border: none;
  }
`;

export const ButtonGhost: any = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.rule.ruleList.white};
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.rule.ruleList.primary};
  cursor: pointer;
`;

ButtonGhost.Icon = styled.img`
  margin-right: 8px;
`;

export const List = styled.ol`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-bottom: 32px;
  &:last-child {
    margin-bottom: 50px;
  }
`;

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.rule.greyLight};
  text-align: center;
  font-weight: normal;
`;
